import { render, staticRenderFns } from "./ViewTestResult.vue?vue&type=template&id=4c55e558"
import script from "./ViewTestResult.vue?vue&type=script&lang=js"
export * from "./ViewTestResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports